<template>
  <div class="al">
    <popupok
      v-if="activeOk === true"
      :want-to-make-offer="activeOk"
      message="Candidature enregistrer avec succès"
      @oga="retourOk"
    />
    <div class="mt-4">
      <input2
        placeholder="Nom complet"
        @info="retourName"
      />

      <input2
        placeholder="Téléphone"
        type="number"
        class="mt-4"
        @info="retourPhone"
      />

      <input2
        placeholder="Email"
        class="mt-4"
        @info="retourEmail"
      />

      <upload
        placeholder="CV"
        class="mt-4"
        @info="retourFile"
      />
      <div
        v-if="error !== null"
        class="text-center text-red mt-8"
      >
        {{ error }}
      </div>

      <div
        class="button mt-16 md:mb-0 mb-10"
        @click="save"
      >
        <scale-loader
          v-if="charge === true"
          :color="loaderColor"
          class="text-center"
        />
        <span v-if="charge === false">
          Postuler
        </span>
      </div>
    </div>
  </div>
</template>

<script>
import input2 from '@/components/helper/form/input2'
import upload from '@/components/helper/form/upload'
import * as firebase from 'firebase'
import popupok from '@/components/popup/popupok'
import axios from 'axios'
import ScaleLoader from 'vue-spinner/src/BeatLoader'

export default {
  name: 'Index',
  components: {
    input2,
    upload,
    popupok,
    ScaleLoader
  },
  props: {
    donnes: {
      type: Object,
      default: null
    }
  },
  data () {
    return {
      loaderColor: '#FFF',
      charge: false,
      fullName: '',
      phone: '',
      email: '',
      file: null,
      error: null,
      activeOk: false
    }
  },
  created () {
  },
  methods: {
    retourName (answer) {
      this.fullName = answer
    },
    retourPhone (answer) {
      this.phone = answer
    },
    retourEmail (answer) {
      this.email = answer
    },
    retourFile (answer) {
      this.file = answer
    },
    retourOk (answer) {
      this.activeOk = answer
    },

    save () {
      this.error = null
      if (this.fullName !== null && this.email.length !== null && this.phone.length !== null && this.file !== null) {
        this.charge = true
        firebase.storage().ref('CV/' + this.file.name).put(this.file)
          .then(response => {
            response.ref.getDownloadURL().then((downloadURL) => {
              this.sendMail(downloadURL)
            })
          })
          .catch((erreur) => {
            this.error = "Impossible d'enregistrer le CV entrer veuillez vérifier votre connexion et ressayer"
            console.log('Erreur:', erreur)
          })
      } else {
        this.error = 'Veuillez remplir les champs et ressayer'
      }
    },

    sendMail (pdf) {
      axios.defaults.withCredentials = true
      axios.defaults.headers.common['x-api-key'] = '3add749b-768b-45ec-a7db-91d3c1915b76'
      const content = 'Fullname: ' + this.fullName + '; Email:' + this.email + ' Phone number: ' + this.phone + '; Poste:' + this.donnes.title + '; CV: ' + pdf
      console.log(content)
      axios.post('https://octabis.kgeek.me/api/v1/utilities/send-mail', {
        'receiver': 'contact@41devs.com',
        'sender': this.email,
        'senderName': this.fullName,
        'object': 'CANDIDATURE',
        'content': content
      }).then(response => {
        this.activeOk = true
        this.charge = false
      }).catch(error => {
        this.charge = false
        console.log(error)
      })
    }
  }
}
</script>

<style lang="scss" scoped>
  @import "../../../assets/style/sass/variables";
  .button{
    background-color: $dev-green;
    height: 60px;
    border-radius: 0px;
    border: none;
    font-style: normal;
    font-weight: 600;
    font-size: 24px;
    line-height: 29px;
    color: white;
    width: 30%;
  }
  @media screen and (max-width: 600px){
    .button{
      height: 60px;
      font-size: 20px;
      width: 100%;
    }
  }

</style>
